import { Box } from "@mui/material";
import { CustomTabPanelProps } from "./types";

const CustomTabPanel = ({ value, index, sx, children }: CustomTabPanelProps) => {
  return (
    <Box sx={{
      ...(value !== index ? { display: "none" } : null),
      ...sx
    }}>
      {value === index ? children : null}
    </Box>
  );
};

export default CustomTabPanel;